import RenderHTML, { defaultSystemFonts } from 'react-native-render-html';
import { FC } from 'react';
import { SPACING } from '../../../config/designSystem/Spacing';
import { ScrollView, View } from 'react-native';
import { SessionPresentationProps } from '../config';
import { observer } from 'mobx-react';
import { useBreakpointStyles } from '../../../hooks/useBreakpointStyles';
import { useContentMaxWidth } from '../../../hooks/ui/useContentMaxWidth';
import { useStores } from '../../../hooks/useStores';

const _PresentText: FC<SessionPresentationProps> = () => {

  const { treeNav } = useStores();
  const sessionStep = treeNav.content.sessionStep;

  // the session already constrains its content to useContentMaxWidth():
  // only the small side margins are needed here
  const styles = useBreakpointStyles({
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: SPACING['sp-16'],
    }
  });
  const width = useContentMaxWidth() - 2 * SPACING['sp-16'];

  const source = {
    html: `${sessionStep?.text ? sessionStep.text : ''}`,
  };

  const systemFonts = [
    'QuattrocentoSans_400Regular',
    'QuattrocentoSans_700Bold',
    'PublicSansBold',
    'PublicSansRegular',
    ...defaultSystemFonts,
  ];

  const WebDisplay = (params: {width: number, source: {html: string}}) => {
    const source = params.source;
    const width = params.width;
    return (
      <RenderHTML
        // a warning is shown if we don't set a specific width
        contentWidth={width}
        source={source}
        systemFonts={systemFonts}
      />
    );
  };

  const WebDisplayMemo = WebDisplay;

  return (
    <View>
      <View style={{ justifyContent: 'center' }}>
        <ScrollView
          contentContainerStyle={styles.container}
        >
          {!!source && !!source?.html && <WebDisplayMemo source={source} width={width} />}
        </ScrollView>
      </View>
    </View>
  );
};

export const PresentText = observer(_PresentText);
